import { render } from "./HomeIntro.vue?vue&type=template&id=a2deddc4&scoped=true"
import script from "./HomeIntro.vue?vue&type=script&lang=js"
export * from "./HomeIntro.vue?vue&type=script&lang=js"

import "./HomeIntro.vue?vue&type=style&index=0&id=a2deddc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2deddc4"]])

export default __exports__